<template>
	<div style="margin-left: 24px; padding-top: 24px">
		<div style="display: flex;">
			<el-input
				v-model="verifyCode"
				maxlength="6"
				placeholder="请输入图形验证码"
				style="width: 180px; height: 40px; margin-right: 12px"
				@input="verifyError = false"
			/>
			<el-image
				:src="imageSrc"
				style="width: 94px; height: 38px; margin-right: 12px;"
			/>
			<i
				class="iconfont icon icon-shuaxin"
				style="cursor: pointer; font-size: 20px; color: #8f98aa; margin-top: -10px;"
				@click="onClickRefresh"
			/>
		</div>
		<div v-if="verifyError" style="color: #fc4f24;">
			<i class="icon iconfont icon-icon-cuowu" />
			<div style="display: inline">验证码错误，请重新输入</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import * as easy from "@/components/easy"; 
import { Images } from '@/assets/Images'
import { catchError } from '@/utils/utils'

import { checkImageVerifyCode, getImageVerifyCode } from '@/api/LoginAPI'

const props = defineProps<{
	popupCtx?: easy.PopupCtx<string> // 返回验证码
}>()

const verifyCode = ref('')

// 服务端返回的ID
let captchaId = '';

const verifyError = ref(false)
function onClickRefresh() {
  verifyError.value = false
  refreshImageVerifyCode()
}

// 显示的图片
const imageSrc = ref();

async function refreshImageVerifyCode() {
	imageSrc.value = Images.VERIFYCODE_REFRESH;
	
  let { response, error } = await catchError(getImageVerifyCode({captchaId}))
	if (error) {
    //if (specTimeOutCheck(error)) {
			imageSrc.value = Images.TRY_AGAIN
    //}
  } else {
    if (response!.code !== 0) {
			imageSrc.value = Images.TRY_AGAIN

			throw new easy.TipError(response!.message);
    }
		imageSrc.value = response!.data.imageData
    captchaId = response!.data.captchaId
  }
}

onMounted(refreshImageVerifyCode)

const popup = easy.usePopup(props);
popup.resultDef(async ({loading}) => {
	if (!verifyCode.value) return

  if (verifyCode.value.length !== 4) {
    verifyError.value = true
    return
  }
  verifyError.value = false

	loading.value = true;
  //验证图片验证码
  let response = await checkImageVerifyCode({
		captchaId: captchaId,
    authCode: verifyCode.value,
  })

  if (response.code !== 0) {
    verifyError.value = true
    verifyCode.value = ''
    await refreshImageVerifyCode()
    return
  }

	popup.done(captchaId);
});

</script>

<style lang="scss" scoped>
* {
	font-size: 14px;
	line-height: 52px;
	font-weight: 500;
}
</style>
